/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Node, format } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
// import styled from 'styled-components';
// @ts-ignore
// import { Cart } from '../../../eden/eden-icons';
// @ts-ignore
import { Cart } from '@churchofjesuschrist/eden-icons';
import { getUrlSync } from '@msdyn365-commerce/core';
import { ICartIconViewProps } from '@msdyn365-commerce-modules/cart/src/modules/cart-icon/./cart-icon';
import { IFlyoutCartLineItemViewProps } from '@msdyn365-commerce-modules/cart/src/modules/cart-icon/./components/flyout-cart-line-items';
//@ts-ignore
import { Info } from '@churchofjesuschrist/eden-alert';
//@ts-ignore
import { Primary } from '@churchofjesuschrist/eden-buttons';

import { getAttributeValuesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';

const CartQuantityBadge: React.CSSProperties = {
    fontFamily: `"Ensign:Sans",Arial,"noto sans" ,sans-serif`,
    fontSize: '11px',
    backgroundColor: '#007da5',
    borderRadius: '50%',
    height: '20px',
    width: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    marginLeft: '4px'
};

const CartContainer: React.CSSProperties = {
    cursor: 'pointer',
    color: 'var(--msv-font-primary-color)',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center'
};

const CartIcon: React.CSSProperties = {
    cursor: 'pointer'
};

const _renderCartlines = (
    cartLines: IFlyoutCartLineItemViewProps[] | undefined,
    props: ICartIconViewProps,
    adobeData: any
): JSX.Element[] | null => {
    if (!cartLines) {
        props.context.telemetry.error('Cartlines content is empty, module wont render');
        return null;
    }
    return cartLines.map((cartLine, index) => {
        let item: any;
        const { Name, Dimensions, Price, ItemId } = cartLine.data.product;
        const language = Dimensions?.filter((dimension: any) => {
            return dimension.DimensionTypeValue === 4;
        });
        const Style = Dimensions?.filter((dimension: any) => {
            return dimension.DimensionTypeValue === 1;
        });
        const Size = Dimensions?.filter((dimension: any) => {
            return dimension.DimensionTypeValue === 3;
        });

        const productLang = language && language[0] && language[0].DimensionValue ? language[0].DimensionValue.Value : '';
        const productStyle = Style && Style[0] && Style[0].DimensionValue ? Style[0].DimensionValue.Value : '';
        const productSize = Size && Size[0] && Size[0].DimensionValue ? Size[0].DimensionValue.Value : '';
        const skuNum = adobeData.filter((item: any) => {
            return (
                item.info.id === ItemId &&
                item.info.language === productLang &&
                item.info.style === productStyle &&
                item.info.size === productSize
            );
        });
        item = {
            info: {
                sku: skuNum[0] ? skuNum[0].info.sku : '',
                id: ItemId,
                name: Name,
                language: language && language[0] && language[0].DimensionValue ? language[0].DimensionValue.Value : '',
                style: Style && Style[0] && Style[0].DimensionValue ? Style[0].DimensionValue.Value : '',
                size: Size && Size[0] && Size[0].DimensionValue ? Size[0].DimensionValue.Value : ''
            },
            quantity: cartLine.data.cartline.Quantity,
            price: {
                basePrice: Price
            }
        };

        const refreshPage = () => {
            // @ts-ignore
            if (window && window['digitalData']) {
                // @ts-ignore
                window['digitalData'].push({
                    event: 'Remove from Cart',
                    product: [item]
                });
            }
            if (cartLine.data.cartline.LineNumber === 1 && props.context.request.urlTokens.pageType === 'Product') {
                // window.location.reload();
            } else if (props.context.actionContext.requestContext.telemetryPageName === 'CheckoutPage') {
                window.location.reload();
            }
        };
        return (
            <Node {...props.miniCartItemWrapper} key={index}>
                {cartLine.cartline}
                {cartLine.storeLocation}
                <div onClick={() => refreshPage()}>{cartLine.remove}</div>
            </Node>
        );
    });
};

const CartIconView: React.FC<ICartIconViewProps> = (props: any) => {
    const [checkoutProducts, setCheckoutProducts] = React.useState<any>([]);
    let cartQuantity = 0;
    props.cartlines?.map((line: { cartline: { props: { currentQuantity: number } } }) => {
        cartQuantity = cartQuantity + line.cartline.props.currentQuantity;
    });

    const getSku = async (Product: any) => {
        const ctx = { callerContext: props.context.actionContext };
        let productDetails;
        if (props.data.products.result) {
            productDetails = props.data.products.result.filter((product: any) => {
                return product.RecordId === Product.ProductId;
            });
        }
        if (productDetails && productDetails.length > 0) {
            const { RecordId, Name, Dimensions, Price, ItemId } = productDetails[0];

            const productAttributes = await getAttributeValuesAsync(ctx, RecordId, props.context.request.channel!.RecordId, 0).catch(
                (err: any) => {
                    console.log(err);
                }
            );
            const language = Dimensions?.filter((dimension: any) => {
                return dimension.DimensionTypeValue === 4;
            });
            const Style = Dimensions?.filter((dimension: any) => {
                return dimension.DimensionTypeValue === 1;
            });
            const Size = Dimensions?.filter((dimension: any) => {
                return dimension.DimensionTypeValue === 3;
            });
            let fulfillableSku;
            if (productAttributes) {
                fulfillableSku = productAttributes.filter((item: any) => {
                    return item.RecordId === 5637144592;
                });
            }

            const adobeItem = {
                info: {
                    sku: fulfillableSku ? fulfillableSku[0].TextValue : '',
                    id: ItemId,
                    name: Name,
                    language: language && language[0] && language[0].DimensionValue ? language[0].DimensionValue.Value : '',
                    style: Style && Style[0] && Style[0].DimensionValue ? Style[0].DimensionValue.Value : '',
                    size: Size && Size[0] && Size[0].DimensionValue ? Size[0].DimensionValue.Value : ''
                },
                quantity: Product.Quantity,
                price: {
                    basePrice: Price
                }
            };

            setCheckoutProducts((prevState: any) => [...prevState, adobeItem]);
        }
    };

    React.useEffect(() => {
        if (props.data.cart && props.data.cart.result) {
            props.data.cart.result.cart.CartLines.map((item: any) => {
                void getSku(item);
            });
        }
    }, [props.data.cart, props.data.cart.result]);

    const AdobeAnalyticsCheckout = () => {
        // @ts-ignore
        if (window && window['digitalData']) {
            // @ts-ignore
            window['digitalData'].push({
                event: 'Checkout',
                cart: { item: checkoutProducts }
            });
        }
        sessionStorage.setItem('taxIdCheck', 'false');
        sessionStorage.setItem('idNum', '');
        sessionStorage.setItem('TaxId', '');
        sessionStorage.setItem('taxIdRegion', '');
        sessionStorage.setItem('emailOnCart', 'false');

        // @ts-ignore
        window.location.assign(props.checkoutAsSignInUserButton.props.href);
    };

    return (
        <Node {...props.miniCartWrapper} {...props.renderModuleAttributes(props)}>
            <a
                style={CartContainer}
                title={format(props.resources.cartLabel, cartQuantity)}
                href={getUrlSync('cart', props.context.actionContext)}
            >
                <Cart size='1.27rem' style={CartIcon}></Cart>
                <div style={CartQuantityBadge}>{cartQuantity}</div>
            </a>
            {props.FlyoutContainer ? (
                <Node {...props.FlyoutContainer}>
                    {props.data.cart.result?.isEmpty ? props.slots.emptyCart : null}
                    {props.flyoutTitle}
                    <Node {...props.CartlinesWrapper}>{_renderCartlines(props.cartlines, props, checkoutProducts)}</Node>
                    {props.totalPrice}
                    {cartQuantity !== 0 && (
                        <Info style={{ paddingBottom: '10px' }}>
                            <div style={{ lineHeight: '17px' }}>
                                {format(props.resources.currencyFeeMessage, props.context.cultureFormatter.currencyCode)}
                            </div>
                        </Info>
                    )}
                    {/* {props.checkoutAsSignInUserButton} */}
                    {props.checkoutAsSignInUserButton && props.context.request.telemetryPageName !== 'CartPage' && (
                        <Primary
                            title={props.checkoutAsSignInUserButton.props.title ? props.checkoutAsSignInUserButton.props.title : ''}
                            // href={props.checkoutAsSignInUserButton.props.href ? props.checkoutAsSignInUserButton.props.href : ''}
                            onClick={() => AdobeAnalyticsCheckout()}
                            tag={props.checkoutAsSignInUserButton.props.tag ? props.checkoutAsSignInUserButton.props.tag : ''}
                            fullWidth={true}
                        >
                            {props.checkoutAsSignInUserButton.props.children ? props.checkoutAsSignInUserButton.props.children : ''}
                        </Primary>
                    )}

                    {/* {props.goToCartButton} */}
                    {props.goToCartButton && (
                        <Primary
                            title={props.goToCartButton.props.title ? props.goToCartButton.props.title : ''}
                            href={props.goToCartButton.props.href ? props.goToCartButton.props.href : ''}
                            tag={props.goToCartButton.props.tag ? props.goToCartButton.props.tag : ''}
                            fullWidth={true}
                        >
                            {props.goToCartButton.props.children ? props.goToCartButton.props.children : ''}
                        </Primary>
                    )}
                </Node>
            ) : (
                false
            )}
        </Node>
    );
};

export default CartIconView;
